// Cookie utility functions for user session management

const COOKIE_EXPIRY_HOURS = 15;

/**
 * Set a cookie with 15-hour expiration
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 */
export const setCookie = (name, value) => {
  const date = new Date();
  date.setTime(date.getTime() + (COOKIE_EXPIRY_HOURS * 60 * 60 * 1000)); // 15 hours in milliseconds
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict;Secure`;
};

/**
 * Get a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

/**
 * Delete a cookie by name
 * @param {string} name - Cookie name
 */
export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

/**
 * Set user session cookies
 * @param {object} user - User object containing email and other details
 */
export const setUserSessionCookies = (user) => {
  if (user) {
    if (user.email) setCookie('userEmail', user.email);
    if (user.name) setCookie('userName', user.name);
    if (user.role) setCookie('userRole', user.role);
    if (user._id) setCookie('userId', user._id);
  }
};

/**
 * Get user email from cookies
 * @returns {string|null} - User email or null if not found
 */
export const getUserEmailFromCookie = () => {
  return getCookie('userEmail');
};

/**
 * Clear all user session cookies
 */
export const clearUserSessionCookies = () => {
  deleteCookie('userEmail');
  deleteCookie('userName');
  deleteCookie('userRole');
  deleteCookie('userId');
};

/**
 * Check if user cookies are still valid (not expired)
 * @returns {boolean} - True if cookies exist and are valid
 */
export const isUserSessionValid = () => {
  return getUserEmailFromCookie() !== null;
};
